import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface CounselorCardProps {
  name: string;
  title: string;
  image: string;
  alt: string;
  specializations: string[];
  languages: string[];
  experience: string;
  rating: number;
  reviewCount: number;
  isSelected: boolean;
  onSelect: () => void;
}

export default function CounselorCard({
  name,
  title,
  image,
  alt,
  specializations,
  languages,
  experience,
  rating,
  reviewCount,
  isSelected,
  onSelect
}: CounselorCardProps) {
  return (
    <div
      onClick={onSelect}
      className={`bg-card border-2 ${
        isSelected ? 'border-conversion' : 'border-border'
      } rounded-xl p-6 cursor-pointer hover:shadow-elevated transition-all duration-smooth transform hover:-translate-y-1`}
    >
      <div className="flex items-start space-x-4">
        <div className="relative w-20 h-20 rounded-full overflow-hidden flex-shrink-0">
          <AppImage
            src={image}
            alt={alt}
            className="w-full h-full object-cover"
          />
          {isSelected && (
            <div className="absolute inset-0 bg-primary/20 flex items-center justify-center">
              <Icon name="CheckCircleIcon" variant="solid" size={32} className="text-primary" />
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold text-foreground">{name}</h3>
          <p className="text-sm text-muted-foreground">{title}</p>
          <div className="flex items-center space-x-1 mt-2">
            <Icon name="StarIcon" variant="solid" size={16} className="text-accent" />
            <span className="text-sm font-semibold text-foreground">{rating}</span>
            <span className="text-sm text-muted-foreground">({reviewCount} reviews)</span>
          </div>
        </div>
      </div>
      <div className="mt-4 space-y-3">
        <div className="flex items-center space-x-2 text-sm text-foreground">
          <Icon name="BriefcaseIcon" size={16} className="text-primary" />
          <span>{experience}</span>
        </div>
        <div>
          <p className="text-xs font-semibold text-muted-foreground mb-1">Specializations:</p>
          <div className="flex flex-wrap gap-2">
            {specializations.map((spec, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-muted text-foreground text-xs rounded-md"
              >
                {spec}
              </span>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold text-muted-foreground mb-1">Languages:</p>
          <p className="text-sm text-foreground">{languages.join(', ')}</p>
        </div>
      </div>
    </div>
  );
}